import { Box, Flex } from '@chakra-ui/react';

import { Shimmer } from 'components/Shimmer';
import { neutral, radius } from 'styles/revampTokens';

/**
 * Stands in for the builder's own shape — nav row, title, category tabs, then
 * the data grid inside its card — rather than a centred spinner, so the page
 * does not rearrange itself once the block loads.
 */
const TAB_COUNT = 3;
const COLUMN_COUNT = 7;
const ROW_COUNT = 12;

const BuilderModeSkeleton = () => (
  <Flex direction='column' height='100%' width='100%' bg={neutral.canvas}>
    <Flex align='center' justify='space-between' px='12px' py='14px'>
      <Shimmer height='10px' width='110px' />
      <Shimmer height='28px' width='130px' control />
    </Flex>

    <Flex align='center' justify='space-between' px='12px' pb='14px'>
      <Shimmer height='22px' width='190px' control />
      <Flex gap='8px'>
        <Shimmer height='28px' width='120px' control />
        <Shimmer height='28px' width='150px' control />
      </Flex>
    </Flex>

    <Flex align='center' gap='8px' px='12px' pb='14px'>
      {Array.from({ length: TAB_COUNT }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Shimmer key={index} height='26px' width='88px' control />
      ))}
    </Flex>

    <Box flex='1' minH={0} px='12px' pb='20px'>
      <Box
        height='100%'
        bg={neutral.surface}
        border={`1px solid ${neutral.border}`}
        borderRadius={radius.surface}
        overflow='hidden'
        display='flex'
        flexDirection='column'
      >
        {/* Header row, then body rows — the grid's own proportions. */}
        <Flex
          align='center'
          gap='16px'
          px='16px'
          height='44px'
          borderBottom={`1px solid ${neutral.border}`}
          bg={neutral.surfaceMuted}
          flexShrink={0}
        >
          {Array.from({ length: COLUMN_COUNT }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Shimmer key={index} height='9px' flex={index === 0 ? '0 0 150px' : '1'} />
          ))}
        </Flex>
        {Array.from({ length: ROW_COUNT }).map((_, rowIndex) => (
          <Flex
            // eslint-disable-next-line react/no-array-index-key
            key={rowIndex}
            align='center'
            gap='16px'
            px='16px'
            height='38px'
            borderBottom={`1px solid ${neutral.borderSubtle}`}
            flexShrink={0}
          >
            {Array.from({ length: COLUMN_COUNT }).map((__, columnIndex) => (
              <Shimmer
                // eslint-disable-next-line react/no-array-index-key
                key={columnIndex}
                height='9px'
                flex={columnIndex === 0 ? '0 0 150px' : '1'}
              />
            ))}
          </Flex>
        ))}
      </Box>
    </Box>
  </Flex>
);

export default BuilderModeSkeleton;
